(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/image-v2/assets/javascripts/helpers/hbs-helpers.js') >= 0) return;  svs.modules.push('/components/content/image-v2/assets/javascripts/helpers/hbs-helpers.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const cmsImagePrefix = '/cms/images';
const _svs = svs,
  isServer = _svs.isServer;
const _svs$utils = svs.utils,
  svsuid = _svs$utils.svsuid,
  getFileFormat = _svs$utils.getFileFormat;
const _ref = isServer ? require("".concat(__dirname, "/to-array-or-null.es6")) : svs.content.image_v2.helpers,
  toArrayOrNull = _ref.toArrayOrNull;

const getUrlWithCorrectHost = (url, config) => {
  if (!url) {
    return '';
  }

  const isAbsolute = /^(https?:)?\/\/.*/.test(url);

  const encodeFilename = function (_fullMatch, name) {
    let ext = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return "".concat(encodeURIComponent(decodeURIComponent(name))).concat(ext);
  };

  if (isAbsolute) {
    return url.replace(/([^/]+?)(\.[^/.]+)?(?=[?#]|$)/, encodeFilename);
  }

  return "".concat(config.options.cdn2).concat(url.replace(/([^/]+?)(\.[^/.]+)?(?=[?#]|$)/, encodeFilename));
};

const getUrlWithFilledPlaceholders = (url, width, extension) => {
  const picassoData = "".concat(width, "/").concat(extension);
  return url.replace(new RegExp("^".concat(cmsImagePrefix)), "".concat(cmsImagePrefix, "/").concat(picassoData));
};

const getWithFilledPlaceholders = (url, width, extension) => url.replace('{width}', width).replace('{extension}', extension);

const isOriginalImage = image => {
  if (!(image !== null && image !== void 0 && image.url)) {
    return false;
  }
  const fileFormat = getFileFormat(image.url);
  return Boolean((image === null || image === void 0 ? void 0 : image.originalImage) || (fileFormat === null || fileFormat === void 0 ? void 0 : fileFormat.extension) === 'svg');
};

const getImageProminentColor = image => (image === null || image === void 0 ? void 0 : image.dominantColor) || null; 

const getUrl = (image, extension, width, isFallbackImg) => {
  var _image$url, _extension;
  let url = (image === null || image === void 0 || (_image$url = image.url) === null || _image$url === void 0 ? void 0 : _image$url.replace(/-({width}|%7Bwidth%7D)/g, '')) || '';
  if (isFallbackImg || isOriginalImage(image)) {
    return url;
  }
  if (image !== null && image !== void 0 && image.isPreview && !extension) {
    return url;
  }
  url = getWithFilledPlaceholders(url, width, extension);
  extension = ((_extension = extension) === null || _extension === void 0 ? void 0 : _extension.replace(/\./g, '')) || 'original';
  return getUrlWithFilledPlaceholders(url, width, extension);
};

const getSrcsetString = (image, extension, width, config) => {
  let output = getUrl(image, extension || 'auto', width);
  output = getUrlWithCorrectHost(output, config);
  return "".concat(output).concat(isNaN(width) ? '' : " ".concat(width, "w"));
};

const getBestAvailableWidth = image => {
  var _image$availableWidth, _image$aspectRatio;
  const availableWidths = image === null || image === void 0 || (_image$availableWidth = image.availableWidths) === null || _image$availableWidth === void 0 ? void 0 : _image$availableWidth.map(value => Number(value)).filter(value => !isNaN(value)).sort((first, second) => first - second);
  if (!(availableWidths !== null && availableWidths !== void 0 && availableWidths.length)) {
    return null;
  }
  const targetWidth = Number((image === null || image === void 0 || (_image$aspectRatio = image.aspectRatio) === null || _image$aspectRatio === void 0 ? void 0 : _image$aspectRatio.width) || (image === null || image === void 0 ? void 0 : image.width));
  if (isNaN(targetWidth) || targetWidth <= 0) {
    return availableWidths[availableWidths.length - 1];
  }
  return availableWidths.find(candidate => candidate >= targetWidth) || availableWidths[availableWidths.length - 1];
};

const getFallbackImage = (image, images, isMultiImage) => {
  if (!isMultiImage) {
    return image;
  }
  return Object.values(images || {}).reduce((prev, curr) => (prev === null || prev === void 0 ? void 0 : prev.width) > (curr === null || curr === void 0 ? void 0 : curr.width) ? prev : curr, {
    width: 0
  }) || null;
};

function registerHelpers(hbs, config) {
  const helpers = {
    getUrlWithCorrectHost,
    contentImageHeight: _ref2 => {
      let height = _ref2.height,
        width = _ref2.width;
      return width && height ? height / width * 100 : 43.75;
    },
    getUniqueSelector: () => "image-".concat(svsuid()),
    isOriginalImage,
    getImageProminentColor,
    getSrcset: (image, extension) => {
      var _image$availableWidth2;
      const srcsetArray = (image === null || image === void 0 || (_image$availableWidth2 = image.availableWidths) === null || _image$availableWidth2 === void 0 ? void 0 : _image$availableWidth2.map(width => getSrcsetString(image, extension, width, config))) || getUrlWithCorrectHost(getUrl(image, extension), config);
      return new hbs.SafeString(srcsetArray.toString());
    },
    setVar(name, value) {
      this[name] = value;
    },
    getSourceElementsData: image => {
      if (!image) {
        return [];
      }
      const media = image.media,
        imageSizes = image.sizes;
      const sizes = imageSizes || '100vw';
      const srcSet = helpers.getSrcset(image, 'auto');
      return [{
        id: svsuid(),
        media,
        sizes,
        srcSet
      }];
    },
    getDefaultImgUrl(image, images, imageUrl, isMultiImage) {
      const fallbackImage = getFallbackImage(image, images, isMultiImage);
      const fallbackWidth = getBestAvailableWidth(fallbackImage);
      const url = imageUrl || getUrl(fallbackImage, 'auto', fallbackWidth, !fallbackWidth);
      return getUrlWithCorrectHost(url, config);
    },
    stringifyImagesObject: input => {
      const imagesArray = toArrayOrNull(input);
      if (!imagesArray) {
        return null;
      }
      return JSON.stringify(imagesArray.map(item => item && {
        aspectRatio: item.aspectRatio,
        dominantColor: item.dominantColor,
        media: item.media
      }));
    },
    setStyleElement(selector, imagesObject) {
      if (svs.isBrowser) {
        const setStyleElement = svs.content.image_v2.helpers.multiImageStyleElement.setStyleElement;
        setStyleElement(selector, imagesObject);
      }
    },
    getNoscriptUrl(image, images, noscriptUrl, isMultiImage) {
      const fallbackImage = getFallbackImage(image, images, isMultiImage);
      const fallbackWidth = getBestAvailableWidth(fallbackImage);
      const url = noscriptUrl || getUrl(fallbackImage, null, fallbackWidth, !fallbackWidth);
      return getUrlWithCorrectHost(url, config);
    }
  };
  Object.entries(helpers).forEach(_ref3 => {
    let _ref4 = _slicedToArray(_ref3, 2),
      name = _ref4[0],
      fn = _ref4[1];
    return hbs.registerHelper(name, fn);
  });
}
if (isServer) {
  const _require = require('@svenskaspelab/trinidad-core'),
    core = _require.core;
  registerHelpers(require('hbs'), core.config);
} else {
  var _svs$core;
  const config = {
    options: (_svs$core = svs.core) === null || _svs$core === void 0 || (_svs$core = _svs$core.config) === null || _svs$core === void 0 || (_svs$core = _svs$core.data) === null || _svs$core === void 0 ? void 0 : _svs$core.svsconfig
  };
  registerHelpers(Handlebars, config);
}

 })(window);